import React from 'react';
import About from '../components/sections/About';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <About />
    </div>
  );
};

export default AboutPage;
